import { useState } from 'react';
import { toast } from 'react-toastify';
import { handlePaymentRedirect } from '../helper/handlePaymentRedirect';
import AppointmentService from '../services/Appointment.service';

export const usePaymentHandler = () => {
  const [isLoading, setLoading] = useState(false);

  const payAppointment = async (appointmentId: number) => {
    try {
      setLoading(true);
      const response = await AppointmentService.payAppointment(appointmentId);

      if (!response.error && response.data && response.data.redirectUrl) {
        const paymentUrl = response.data.redirectUrl;

        handlePaymentRedirect(paymentUrl);
      } else {
        console.error('API Error:', response);
        toast.error('Ein unerwarteter Fehler ist aufgetreten.');
      }
    } catch (error) {
      console.error('API Error:', error);
      toast.error('Ein unerwarteter Fehler ist aufgetreten.');
    } finally {
      setLoading(false);
    }
  };

  return { isLoading, payAppointment };
};
